import { analytics } from "@kaihong/Beacon-OTLP";

// 支持通过环境变量注入配置，同时提供默认值
const endpoint = '/api/beacon';
const appName = "kh-iot-web";
const appVersion = "1.0.0";
let env: "prod" | "dev" | "test" = "prod";

const host = window.location.host;

if (host.includes("test")) {
  env = "test";
} else if (host.includes("dev")) {
  env = "dev";
} else {
  env = "prod";
}

export const init = () => {
  // 初始化SDK
  analytics.init({
    endpoint,
    appName,
    appVersion,
    env,
    enableClickTracking: true,  // ← 必须显式启用
    reportInterval: 30000, // 上报间隔（30秒）
  });
};

// 用户登录后设置
export function onUserLogin(user: any) {
  analytics.setUser(user.id, {
    username: user.name,
    role: user.role,
  });
}

// 更新用户属性
export function onUserUpgrade(newPlan: string) {
  analytics.setUserProperties({
    plan: newPlan,
    upgraded_at: new Date().toISOString(),
  });
}

export { analytics };
